export const publicPageGutters = 'px-4 sm:px-12 xl:px-20 2xl:px-40';

const routesWithPublicPageGutters = new Set([
  '/',
  '/research',
  '/company',
  '/contact',
  '/pricing',
  '/pricing/individual-plans',
  '/pricing/team-plans',
  '/pricing/enterprise-plans',
  '/pricing-new',
  '/data',
  '/plugins',
  '/blog',
  '/privacy-policy',
  '/terms-of-use',
  '/plugin-addendum',
  '/model/comic',
  '/model/swing',
  '/product/performance-capture',
  '/product/performance-generation',
  '/product/performance-editor',
  '/product/cartographer',
]);

export function usesPublicPageGutters(pathname: string) {
  return (
    routesWithPublicPageGutters.has(pathname) ||
    pathname.startsWith('/blog/') ||
    pathname.startsWith('/careers/')
  );
}
